import React from 'react';
import Box from '@mui/material/Box';

export interface WithBoxStyleProps {
  children: React.ReactNode;
}

const WithMobileViewLayout = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const WithMobileViewStyle: React.FC<P & WithBoxStyleProps> = (props) => (
    <Box
      sx={(theme) => ({
        [theme.breakpoints.up('sm')]: {
          width: '100%',
          maxWidth: '390px',
          m: '0 auto',
        },
      })}
      className="d-flex flex-column flex-1 scroll-y"
    >
      <WrappedComponent {...(props as P)} />
    </Box>
  );

  return WithMobileViewStyle;
};

export default WithMobileViewLayout;
